// Auto-generated TypeScript enum from PHP enum

export type PhoneFormat = 'e164' | 'international' | 'national' | 'rfc3966';

export const PhoneFormat = {
  E164: 'e164' as const,
  International: 'international' as const,
  National: 'national' as const,
  Rfc3966: 'rfc3966' as const,
} as const;

export const PhoneFormatUtils = {
  values: Object.values(PhoneFormat),
  keys: Object.keys(PhoneFormat) as Array<keyof typeof PhoneFormat>,
  entries: Object.entries(PhoneFormat) as Array<[keyof typeof PhoneFormat, PhoneFormat]>,
  isValid: (value: any): value is PhoneFormat => Object.values(PhoneFormat).includes(value),
  fromKey: (key: keyof typeof PhoneFormat): PhoneFormat => PhoneFormat[key],
};

